import { IonSpinner } from "@ionic/react";
import { hideModal } from "global/context/action/modal/modal";
import { showToaster } from "global/context/action/toaster/toaster";
import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import "./IngresarToken.css";
import InputV1 from "../InputV1/InputV1";
import { logoutAuth } from "global/context/action/auth/login";
import { GlobalContext } from "global/context/Provider";
import { SegundoFactorContext } from "_+_Portal/_-_SegundoFactor/context/provider";
import { activarTotpReset, wsPostActivarTotp } from "_+_Portal/_-_SegundoFactor/context/action/activarTotp/activarTotp";

const IngresarToken = ({ password }) => {
  const history = useHistory();
  const {
    modalDispatch,
    authState,
    toasterDispatch,
    authDispatch,
    resetGlobalContext,
  } = useContext(GlobalContext);
  const { activarTotpDispatch, activarTotpState, resetSegundoFactorContext } =
    useContext(SegundoFactorContext);
  const [token, setToken] = useState("");
  const [disabled, setDisabled] = useState(true);
  let config = localStorage.getItem("config");
  let opcResetContext = JSON.parse(config).opcResetContext;

  const cerrarModal = () => {
    hideModal()(modalDispatch);
    if (opcResetContext) {
      resetGlobalContext(0);
      resetSegundoFactorContext(0);
      history.push("/segundofactor");
    } else {
      logoutAuth()(authDispatch);
    }
  };

  const onChangeToken = (e) => {
    setToken(e.target.value.toLowerCase());
  };

  useEffect(() => {
    if (token.length > 0) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [token]);

  const enviarToken = () => {
    if (
      authState.auth.data.usuario.usuario !== null &&
      password !== null &&
      token !== null &&
      authState.auth.data.usuario.usuario !== undefined &&
      password !== undefined &&
      token !== undefined
    ) {
      wsPostActivarTotp(
        authState.auth.data.usuario.usuario,
        password,
        token
      )(activarTotpDispatch);
    }
  };
  
  useEffect(() => {
    if (
      activarTotpState.activarTotp.data !== null &&
      !activarTotpState.activarTotp.error
      ) {
        const datos = {
          usuario: authState.auth.data.usuario.usuario,
          token: activarTotpState.activarTotp.data.token,
          nombre: authState.auth.data.usuario.nombre,
          fechaCaducidad: activarTotpState.activarTotp.data.fechaCaducidad,
      };
      localStorage.setItem("dtoSegundoFactor", JSON.stringify(datos));
      hideModal()(modalDispatch);
      obtenerTokenStorage();
    }
    //eslint-disable-next-line
  }, [activarTotpState.activarTotp.data]);
  
  const obtenerTokenStorage = async () => {
    const itemStorage = localStorage.getItem("dtoSegundoFactor");
    const itemToken = JSON.parse(itemStorage);
    if (itemToken) {
      hideModal()(modalDispatch);
      history.push("/segundofactor/home");
    }
  };

  useEffect(() => {
    if (activarTotpState.activarTotp.error) {
      showToaster(
        {
          texto: activarTotpState.activarTotp.error.detail,
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);

      setTimeout(() => {
        activarTotpReset()(activarTotpDispatch);
      }, 5000);
    }
    // eslint-disable-next-line
  }, [activarTotpState.activarTotp.error]);

  useEffect(() => {
    if (authState.auth.data !== null) {
      showToaster(
        {
          texto: authState.auth.data.mensaje
            ? authState.auth.data.mensaje
            : "El código de activación ya fue enviado.",
          tipo: "success",
        },
        "centroArriba"
      )(toasterDispatch);
    }
    //eslint-disable-next-line
  }, [authState.auth.data]);

  return (
    <div className="ingresar-token">
      <div className="ingresar-token-body">
        <div className="ingresar-token-input t-left">
          <InputV1
            headerStr="Token"
            onChange={onChangeToken}
            className="toLowerCase"
          />
        </div>
        <div className="ingresar-token-btn">
          <div
            className="btn btn-ingresarToken bgc-primary c-white rb18m"
            onClick={cerrarModal}
          >
            Cerrar
          </div>

          <div
            className={
              disabled || activarTotpState.activarTotp.loading
                ? "btn btn-ingresarToken bgc-grey65 c-white rb18m"
                : "btn btn-ingresarToken bgc-latex30 c-white rb18m"
            }
            onClick={enviarToken}
            disabled={disabled || activarTotpState.activarTotp.loading}
          >
            <div className="token-spinner">
              {activarTotpState.activarTotp.loading ? (
                <IonSpinner />
              ) : (
                "Ingresar"
              )}{" "}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IngresarToken;
